import { render, staticRenderFns } from "./ReviewCardFooter.vue?vue&type=template&id=516d9702&scoped=true&"
import script from "./ReviewCardFooter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardFooter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardFooter.vue?vue&type=style&index=0&id=516d9702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d9702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516d9702')) {
      api.createRecord('516d9702', component.options)
    } else {
      api.reload('516d9702', component.options)
    }
    module.hot.accept("./ReviewCardFooter.vue?vue&type=template&id=516d9702&scoped=true&", function () {
      api.rerender('516d9702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardFooter.vue"
export default component.exports